import { ZaklynNavbar } from "@/components/marketing/ZaklynNavbar";
import { ZaklynFooter } from "@/components/marketing/ZaklynFooter";
import { ZaklynHero } from "@/components/marketing/ZaklynHero";
import { HeroCarousel } from "@/components/marketing/HeroCarousel";
import { IntentSelector } from "@/components/marketing/IntentSelector";
import { HowItWorks } from "@/components/marketing/HowItWorks";
import { ServicesGrid } from "@/components/marketing/ServicesGrid";
import { BeforeAfterSlider } from "@/components/marketing/BeforeAfterSlider";
import { TestimonialsCarousel } from "@/components/marketing/TestimonialsCarousel";
import { GalleryMasonry } from "@/components/marketing/GalleryMasonry";
import { CoverageSection } from "@/components/marketing/CoverageSection";
import { FAQAccordion } from "@/components/marketing/FAQAccordion";

export default function HomePage() {
  return (
    <>
      <ZaklynNavbar />
      <ZaklynHero />
      <HeroCarousel />
      <IntentSelector />
      <HowItWorks />
      <ServicesGrid />
      <BeforeAfterSlider />
      <TestimonialsCarousel />
      <GalleryMasonry />
      <CoverageSection />
      <FAQAccordion />
      <ZaklynFooter />
    </>
  );
}